export default "__VITE_ASSET__37afb320__"